import { render } from "./teaXlEchart.vue?vue&type=template&id=193a5c7a&scoped=true"
import script from "./teaXlEchart.vue?vue&type=script&lang=js"
export * from "./teaXlEchart.vue?vue&type=script&lang=js"

import "./teaXlEchart.vue?vue&type=style&index=0&id=193a5c7a&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193a5c7a"]])

export default __exports__